var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.681,
    height: 33.681,
    viewBox: "0 0 33.681 33.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.762,25.577a2.526,2.526,0,0,0,2.526-2.526,1.3,1.3,0,0,0,0-.253l4.7-4.7h.775l2.711,2.711v.135a2.526,2.526,0,1,0,5.052,0v-.135l6.13-6.18h0A2.526,2.526,0,1,0,30.129,12.1a1.3,1.3,0,0,0,0,.253l-6.079,6.079H23.78l-2.913-2.964a2.526,2.526,0,1,0-5.052,0l-5.052,5.052h0a2.526,2.526,0,0,0,0,5.052ZM33.5,32.313H4.868V3.684a1.684,1.684,0,1,0-3.368,0V34a1.684,1.684,0,0,0,1.684,1.684H33.5a1.684,1.684,0,0,0,0-3.368Z",
    transform: "translate(-1.5 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsDark);
export default __webpack_public_path__ + "static/media/analytics-dark.9f75af941d175890739954986a4a70cc.svg";
export { ForwardRef as ReactComponent };